/**
 * error 頁面判斷用
 */
export enum ErrorCode {
  /** 找不到頁面 */
  NOT_FOUND = '404',
  /** 系統錯誤(斷線時) */
  SYSTEM_MAINTAIN = 'system-maintain'
}
